import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref, reactive } from "vue";
import Loading from "./components/Loading.vue";
import { onMounted } from "vue";
// 对编辑器有影响
// onMounted(() => {
//   // 禁用选择
//   document.onselectstart = new Function("event.returnValue=false");
//   // 禁用右键
//   document.oncontextmenu = new Function("event.returnValue=false");
// });

export default {
  __name: 'App',
  setup(__props) {
    const font = reactive({
      color: "rgba(0, 0, 0, .08)"
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      const _component_el_watermark = _resolveComponent("el-watermark");
      return _openBlock(), _createBlock(_component_el_watermark, {
        font: font,
        content: ['demo', '演示数据']
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view)]),
        _: 1
      }, 8, ["font"]);
    };
  }
};